import { request, seg } from "./http";
import type { Billing, Plan, Promotion } from "./types";

export const billingApi = {
  plans: (signal?: AbortSignal) => request<{ plans: Plan[]; promotion: Promotion | null }>("GET", "/v1/plans", undefined, { signal }),
  state: (workspaceId: string, signal?: AbortSignal) =>
    request<Billing>("GET", `/v1/workspaces/${seg(workspaceId)}/billing`, undefined, { signal }),
  checkout: (workspaceId: string, planPriceId: string, promoCode?: string) =>
    request<{ checkoutUrl: string }>("POST", `/v1/workspaces/${seg(workspaceId)}/billing/checkout`, { planPriceId, ...(promoCode ? { promoCode } : {}) })
      .then((r) => r.checkoutUrl),
  portal: (workspaceId: string) =>
    request<{ portalUrl: string }>("GET", `/v1/workspaces/${seg(workspaceId)}/billing/manage-links`).then((r) => r.portalUrl),
  changePlan: (workspaceId: string, planPriceId: string) =>
    request<unknown>("POST", `/v1/workspaces/${seg(workspaceId)}/billing/change-plan`, { planPriceId }),
};
